import { render, staticRenderFns } from "./CommunityFAQ.vue?vue&type=template&id=969eac9e&scoped=true&"
import script from "./CommunityFAQ.vue?vue&type=script&lang=ts&"
export * from "./CommunityFAQ.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityFAQ.vue?vue&type=style&index=0&id=969eac9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969eac9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('969eac9e', component.options)
    } else {
      api.reload('969eac9e', component.options)
    }
    module.hot.accept("./CommunityFAQ.vue?vue&type=template&id=969eac9e&scoped=true&", function () {
      api.rerender('969eac9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/CommunityFAQ.vue"
export default component.exports